import React, { useContext, useState, useEffect } from 'react'
import './Navbar.css'
import logo from '../Assets/Frontend_Assets/logo.png'
import cart_icon from '../Assets/Frontend_Assets/cart_icon.png'
import { Link } from 'react-router-dom'
import { ShopContext } from '../../Context/ShopContext'

export const Navbar = () => {
    const [menu, setMenu] = useState("shop");
    const { getTotalCartItems } = useContext(ShopContext)
    const [mobileMenuOpen, setMobileMenuOpen] = useState(false);
    const [isDarkMode, setIsDarkMode] = useState(false);

    useEffect(() => {
        const savedTheme = localStorage.getItem('darkMode') === 'true';
        setIsDarkMode(savedTheme);
        if (savedTheme) {
            document.body.classList.add('dark-mode');
        }
    }, []);

    const toggleDarkMode = () => {
        const newMode = !isDarkMode;
        setIsDarkMode(newMode);
        localStorage.setItem('darkMode', newMode);

        if (newMode) {
            document.body.classList.add('dark-mode');
        } else {
            document.body.classList.remove('dark-mode');
        }
    };

    const toggleMobileMenu = () => {
        setMobileMenuOpen(!mobileMenuOpen);
    };

    const handleMenuClick = (menuType) => {
        setMenu(menuType);
        setMobileMenuOpen(false);
    };

    return (
        <div className='navbar'>
            <div className="nav-logo">
                <img src={logo} alt="" />
                <p>STORE</p>
            </div>

            <div className="mobile-menu-toggle" onClick={toggleMobileMenu}>
                <div className={`bar ${mobileMenuOpen ? 'change' : ''}`}></div>
                <div className={`bar ${mobileMenuOpen ? 'change' : ''}`}></div>
                <div className={`bar ${mobileMenuOpen ? 'change' : ''}`}></div>
            </div>

            <ul className={`nav-menu ${mobileMenuOpen ? 'active' : ''}`}>
                <li onClick={() => handleMenuClick("shop")}>
                    <Link style={{ textDecoration: 'none' }} to='/'>Shop</Link>
                    {menu === "shop" ? <hr /> : <></>}
                </li>
                <li onClick={() => handleMenuClick("mens")}>
                    <Link style={{ textDecoration: 'none' }} to='/mens'>Men</Link>
                    {menu === "mens" ? <hr /> : <></>}
                </li>
                <li onClick={() => handleMenuClick("womens")}>
                    <Link style={{ textDecoration: 'none' }} to='/womens'>Women</Link>
                    {menu === "womens" ? <hr /> : <></>}
                </li>
                <li onClick={() => handleMenuClick("kids")}>
                    <Link style={{ textDecoration: 'none' }} to='/kids'>Kids</Link>
                    {menu === "kids" ? <hr /> : <></>}
                </li>

                <div className="mobile-login-cart">
                    <Link to='/login' onClick={() => setMobileMenuOpen(false)}>
                        <button className='mobile-login-btn'>Login</button>
                    </Link>
                    <Link to='/cart' className="mobile-cart-link" onClick={() => setMobileMenuOpen(false)}>
                        <img src={cart_icon} alt="" />
                        <div className='mobile-cart-count'>
                            {getTotalCartItems()}
                        </div>
                    </Link>

                    <div className="mobile-dark-toggle" onClick={toggleDarkMode}>
                        <svg viewBox="0 0 24 24" width="28" height="28" fill="none" stroke="currentColor" strokeWidth="2">
                            {isDarkMode ? (
                                <path d="M12 3v1m0 16v1m9-9h-1M4 12H3m15.364 6.364l-.707-.707M6.343 6.343l-.707-.707m12.728 0l-.707.707M6.343 17.657l-.707.707M16 12a4 4 0 11-8 0 4 4 0 018 0z" />
                            ) : (
                                <path d="M20.354 15.354A9 9 0 018.646 3.646 9.003 9.003 0 0012 21a9.003 9.003 0 008.354-5.646z" />
                            )}
                        </svg>
                    </div>
                </div>
            </ul>

            <div className="nav-login-cart">
                <Link to='/login'>
                    <button>Login</button>
                </Link>
                <Link to='/cart' className="cart-link">
                    <img src={cart_icon} alt="" />
                    <div className='nav-cart-count'>
                        {getTotalCartItems()}
                    </div>
                </Link>

                <div className="dark-mode-toggle" onClick={toggleDarkMode}>
                    <svg viewBox="0 0 24 24" width="32" height="32" fill="none" stroke="currentColor" strokeWidth="2">
                        {isDarkMode ? (
                            <path d="M12 3v1m0 16v1m9-9h-1M4 12H3m15.364 6.364l-.707-.707M6.343 6.343l-.707-.707m12.728 0l-.707.707M6.343 17.657l-.707.707M16 12a4 4 0 11-8 0 4 4 0 018 0z" />
                        ) : (
                            <path d="M20.354 15.354A9 9 0 018.646 3.646 9.003 9.003 0 0012 21a9.003 9.003 0 008.354-5.646z" />
                        )}
                    </svg>
                </div>
            </div>
        </div>
    )
}